// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2gDtQ","content":"Consent_content__c4881","footer":"Consent_footer__1YwTr"};